import { Component, Inject } from '@angular/core';
import { ISitemap, SITEMAP } from 'pbc.angular';
import { IFilterConfig, ISelection } from 'pbc.types';

import get from 'lodash/get';
import { Subscription } from 'rxjs';

import { IObjektResponse, ObjektQueryFilterConfig } from 'fa-kt.types';

import { ObjektService } from '../service';

@Component({
  selector: 'fa-kt-objekt-filter',
  templateUrl: './objekt-filter.component.html',
  styleUrls: ['./objekt-filter.component.css'],
})
export class ObjektFilterComponent {
  readonly subscriptions: Subscription[] = [];

  public ObjektFilterConfig: IFilterConfig<IObjektResponse>;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public objekt: ObjektService,
  ) {
    this.ObjektFilterConfig = ObjektQueryFilterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update mapper    */
    /*    update mapper >> */
  }

  ngOnInit() {
    this.subscriptions.push();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(($) => $.unsubscribe());
  }

  private shape(field: string, shapes: ISelection[]): void {
    const index = this.ObjektFilterConfig.findIndex((f) => f.key === field);
    if (index < 0) {
      return;
    }
    this.ObjektFilterConfig[index].selections = shapes;
  }
}
